import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './PageProductPartners.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';

const PARTNER_TEXT = {
  DEFAULT: 'SOME OF OUR TRUSTED PARTNERS',
  PLUS: 'YOUR ACCESS TO CNBC SHOWS',
};

function PageProductPartners() {
  const { productSku } = useSearchParamOrDefaultProps();

  const showPlusPartner = productSku === 'Plus';

  const partnerTitle =
    (showPlusPartner && PARTNER_TEXT.PLUS) || PARTNER_TEXT.DEFAULT;

  return (
    <section
      className={classNames(styles.PageProductPartners, {
        [styles.PageProductPartnersPlus]: showPlusPartner,
      })}
    >
      <div className={styles.PageProductPartnersBody}>
        <div className={styles.PageProductPartnersHeading}>{partnerTitle}</div>
        <div className={styles.partnerLogosContainer}>
          <div
            id="partnerLogos"
            className={classNames(styles.partnerLogos, {
              [styles.plusPartnerLogos]: showPlusPartner,
            })}
          />
        </div>
      </div>
    </section>
  );
}

export default PageProductPartners;
